import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { getUsername } from "helper/helper";

const MyFunctionalComponent = forwardRef(({ clearCallback }, ref) => {
  const newSocket = useRef(WebSocket);

  const handleWebSocket = async () => {
    try {
      const decoded = await getUsername();

      console.log(process.env);

      const baseURL = process.env.REACT_APP_WS_SERVER_DOMAIN;
      //const newSocket = new WebSocket("wss://localhost:5001/popo"); //https://localhost:5001/publish"); //ws://localhost:8080/ws");
      newSocket.current = new WebSocket(baseURL); //https://localhost:5001/publish"); //ws://localhost:8080/ws");

      newSocket.current.onopen = (e) => {
        console.log("WS Connected: ");
        const infoUser = { event: "login", userId: decoded.userId };

        setTimeout(() => {
          console.log("---> SETTIMEOUT status: " + newSocket.current);
          newSocket.current.send(JSON.stringify(infoUser)); //'{ event: "login", userId: 1 }'); //JSON.stringify(infoUser));

          console.log("---> SETTIMEOUT status XXXX ");
        }, 1000);
      };
      newSocket.current.onclose = (e) => {
        console.log("WS Disconnected");
      };
      newSocket.current.onerror = (err) => {
        console.log("WS Error");
      };
      newSocket.current.onmessage = (e) => {
        if (clearCallback != null) {
          clearCallback(e);
          return;
        }
        const data = JSON.parse(e.data);
        console.log("WS Receives: ", data);
      };
    } catch (error) {
      console.log("--->> WS " + error);
    }
  };

  useImperativeHandle(ref, () => ({
    send: (data) => {
      newSocket.current.send(data);
    },
  }));

  useEffect(() => {
    handleWebSocket();
  }, []);
});

export default MyFunctionalComponent;
